@if (messageBoxService.isOpen()) {
<div
  class="fixed inset-0 bg-black/60 overflow-y-auto h-full w-full flex items-center justify-center z-50">
  <div class="relative p-5 border w-96 shadow-xl rounded-md bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100">
    <h2 class="text-xl font-bold mb-4">{{ messageBoxService.data()?.title }}</h2>
    <p class="mb-4">{{ messageBoxService.data()?.message }}</p>
    <div class="flex justify-end space-x-2">
      @if (messageBoxService.data()?.cancelText) {
      <button
        class="btn-secondary"
        data-cy="message-box-button-cancel"
        (click)="onCancel()">
        {{ messageBoxService.data()?.cancelText }}
      </button>
      }
      <button
        class="btn-primary"
        data-cy="message-box-button-confirm"
        (click)="onConfirm()">
        {{ messageBoxService.data()?.confirmText || 'OK' }}
      </button>
    </div>
  </div>
</div>
}